import React, { useEffect, useRef, useState } from 'react';
import { icons } from 'utils/constants';
import { useNavigate } from 'react-router-dom';
import { getUserType } from 'utils/helpers';

const DiceMenu = () => {
  const myRef = useRef();
  const memberType = getUserType();
  const navigate = useNavigate();
  const [isPopup, setIsPopup] = useState(false);

  const handleClickOutside = (e) => {
    if (myRef.current && !myRef.current.contains(e.target)) {
      setIsPopup(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const menuItems = [
    {
      id: 1,
      title: 'Edit Profile',
      icon: icons.editProfile,
      url: '/my-details',
    },
    {
      id: 2,
      title: 'AI Resume',
      icon: icons.AiResumeGif,
      url: '/career-support/build-ai-resume',
    },
    {
      id: 3,
      title: 'Conference & Event',
      icon: icons.conferenceEvent,
      url: '/conferences-and-events/iferp-events/event-list/conference',
    },
    {
      id: 4,
      title: 'Journal & Publication',
      icon: icons.journalPublication,
      url: '/publications/scopus-indexed-journals',
    },
    {
      id: 5,
      title: 'My Post & Network',
      icon: icons.myPostNetwork,
      url: '/network-management/network/posts/discover-posts',
    },
    {
      id: 6,
      title: 'Mentorship & Management',
      icon: icons.mentorshipManagement,
      url: '/mentorship/mentee/all-mentors',
    },
    {
      id: 7,
      title: 'Certificates & Rewards',
      icon: icons.certificatesRewards,
      url: '/certificates-and-rewards',
    },
    {
      id: 8,
      title: 'Help & Support',
      icon: icons.helpSupport,
      url: '/help/help-and-support',
    },
  ];

  // Get current path
  const currentPath = window.location.pathname;
  const [gifKey, setGifKey] = React.useState(0);

  const handleClick = () => {
    setIsPopup(!isPopup);
    setGifKey(prev => prev + 1); 
  };

  return (
    <div className="dice-icon" ref={myRef}>
      <div
        className="position-relative pointer"
        onClick={handleClick}
      >
        <img key={gifKey}
          src={icons.DiceMenuGif} alt='' height={40} width={40} loading='lazy' />
      </div>

      {isPopup && (
        <>
          <div
            className="popup-overlay"
            onClick={() => setIsPopup(false)} 
          ></div>

          <div className="dice-popup-container box-shadow cp-10">
            <div className="row g-2">
              {menuItems.map((item) => {
                const fullUrl = `/${memberType}${item.url}`;
                const isSelected = currentPath.includes(item.url); 

                return (
                  <div key={item.id} className="col-6">
                    <div
                      className="p-2 text-center rounded pointer h-100 d-flex flex-column justify-content-center align-items-center "
                      style={{
                        border: isSelected
                          ? '2px solid #2148C0'
                          : '3px solid #EFF3FF',
                        borderRadius: '12px',

                        backgroundOrigin: isSelected ? 'border-box' : 'initial',
                        backgroundClip: isSelected
                          ? 'padding-box, border-box'
                          : 'initial',
                      }}
                      onClick={() => {
                        navigate(fullUrl);
                        setIsPopup(false);
                      }}
                    >
                      <img
                        src={item.icon}
                        alt=""
                        height={item.id === 2 ? 30 : 28}
                        width={item.id === 2 ? 30 : 28}
                        className="cmb-8"
                        loading='lazy'
                      />
                      <span
                        className="text-12-500-15"
                        style={
                          item.id === 2
                            ? {
                              background:
                                'radial-gradient(50% 50% at 50% 50%, #3A5ECD 0%, #9A55BA 100%)',
                              WebkitBackgroundClip: 'text',
                              WebkitTextFillColor: 'transparent',
                            }
                            : {
                              background: 'linear-gradient(90deg, #2148C0, #0F225A)',
                              WebkitBackgroundClip: 'text',
                              WebkitTextFillColor: 'transparent',
                            }
                        }
                      >
                        {item.title}
                      </span>


                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default DiceMenu;
